<template>
  <PageTemplate>
    <Loader v-if="!isLoaded"/>
    <div v-else>
      <div class="d-flex justify-content-between">
        <h6 class="element-header">
          Detailübersicht
        </h6>
      </div>

      <div class="element-box">
        <div class="d-flex justify-content-end mb-4">
          <CreateButton
              :label="$t('general.button.back')"
              :to="{ name: 'analyticsHome' }">
          </CreateButton>
        </div>

        <Search
            :statusDropdown="unemployedStatus"
            :unemployedDropdown="unemployedDropdown"
            :insuranceNumberDropdown="insuranceNumberDropdown"
            :aaNumberDropdown="aaNumberDropdown"
            :officeDropdown="officeDropdown"
            :filters="filters"
            :loading="isSearching"
            @search="getUnemployedList"/>

        <div class="row align-items-center justify-content-between">
          <div class="mt-3">
            <PerPage :values="[10, 25, 50, 100]" @update:perPage="getUnemployedList"/>

            <div class="customExcelExport">
              <button class="btn btn-primary" @click="downloadFile(
                  `/analytics/unemployed-details-overview/unemployed-excel-export`, undefined, {
                ...filters,
              }, false )">
                {{ $t('general.excel_export') }}
              </button>
            </div>
          </div>
        </div>

        <div class="table-responsive overflow-auto pt-4">
          <table class="table table-striped">
            <thead>
            <tr>
              <th>Kundennumer</th>
              <th>Status</th>
              <th>Vorname</th>
              <th>Nachname</th>
              <th>Standort</th>
              <th>JC/AA Nummer</th>
              <th>Versicherungsnr</th>
              <th style=" text-align: right; padding-right: 30px; min-width: 150px;">{{ $t('general.actions') }}</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(unemployed) in unemployedList.data" :key="unemployed.id">
              <td>{{ unemployed?.customerNumber }}</td>
              <td>{{ unemployed.statusTranslated }}</td>
              <td>{{ unemployed?.firstName }}</td>
              <td>{{ unemployed?.lastName }}</td>
              <td>{{ unemployed?.location?.name }}</td>
              <td>{{ unemployed?.aaNumber }}</td>
              <td>{{ unemployed?.insuranceNUmber }}</td>
              <td class="text-right">
                <button class="btn btn-primary"
                        @click="router.push({
                        name: 'analyticsUnemployedDetailsOverview',
                         params: { id: unemployed?.id }
                        })">
                  Coaching
                </button>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
        <Pagination
            v-if="unemployedList?.pagination?.total_pages > 1"
            :totalPages="unemployedList?.pagination?.total_pages"
            :currentPage="unemployedList?.pagination?.current_page"
            :totalItems="unemployedList?.pagination?.total_items"
            :perPage="unemployedList?.pagination?.items_per_page"
            @pagechanged="getUnemployedList"/>
      </div>
    </div>
  </PageTemplate>
</template>

<script setup>
import analyticsUnemployedDetailsOverviewService from '@/api/Analytics/Unemployed/DetailsOverview';
import CreateButton from '@/components/CreateButton.vue';
import Loader from '@/components/Loader.vue';
import PageTemplate from '@/components/PageTemplate.vue';
import Pagination from '@/components/Pagination.vue';
import PerPage from '@/components/PerPage.vue';
import { CloseToast, ErrorToast } from '@/components/VueToast';
import router from '@/router';
import { getAllUnemployedDropdown, getOfficeDropdown } from '@/shared/dropdowns';
import { downloadFile } from '@/shared/functions';
import { piniaEnumsStore } from '@/store/piniaEnumsStore';
import Search from '@/views/App/Analytics/Unemployed/DetailOverview/UnemployedList/Search.vue';
import { computed, onMounted, ref } from 'vue';

const piniaEnumsState = piniaEnumsStore();

const { unemployedStatus } = computed(() => piniaEnumsState.enums).value;

const filters = ref({
  status: '',
  insuranceNumber: '',
  aaNumber: '',
  lastName: '',
  'officeIds[]': [],
});

const unemployedList          = ref([]);
const unemployedDropdown      = ref([]);
const officeDropdown          = ref([]);
const aaNumberDropdown        = ref([]);
const insuranceNumberDropdown = ref([]);
const isSearching             = ref(false);
const isLoaded                = ref(false);

async function getUnemployedList(page = 1, perPage, passedFilters) {
  CloseToast();

  if (passedFilters) {
    isSearching.value = true;
  }

  const perPageRes = unemployedList.value?.pagination?.items_per_page;
  try {
    const { data }       = await analyticsUnemployedDetailsOverviewService.getAllUnemployed({
      page: page,
      limit: perPage ?? perPageRes,
      ...(passedFilters ? passedFilters : filters.value),
    });
    unemployedList.value = data;
    isSearching.value    = false;
  } catch (error) {
    await ErrorToast(error);
    isSearching.value = false;
  }
}

onMounted(async () => {
  await Promise.all([
    getUnemployedList(),
    getAllUnemployedDropdown(unemployedDropdown, 'lastName', 'lastName'),
    getAllUnemployedDropdown(aaNumberDropdown, 'aaNumber', 'aaNumber'),
    getAllUnemployedDropdown(insuranceNumberDropdown, 'insuranceNumber', 'insuranceNumber'),
    getOfficeDropdown(officeDropdown),
  ]);
  isLoaded.value = true;
});
</script>

<style scoped>

</style>